import { features } from "@/mocks/home";

export default function Features() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
            为什么选择安大师
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            六大核心优势，为您的安全保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-lg p-6 md:p-7 border border-background-200/50 transition-all duration-300 hover:border-accent-300/50 group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 bg-accent-100 rounded-lg flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 font-heading mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}